import React, { useState } from 'react';
import axios from "axios";
import './modal.css';
import { useNavigate } from 'react-router-dom';

function Modal({ active, setActive, change_token, token, setEmail }) {
  const [resending, setResending] = useState(false);
  const navigate = useNavigate();

  const change_email = async (e) => {
    e.preventDefault();
    
    const new_email = e.target.email.value;
    
    if (new_email === "") {
      alert("Please enter a valid email address.");
      return;
    }
  
    try {
      setResending(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/athlete/resend`,
        {
          pending_secret: change_token,
          email: new_email,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      
      if (response.status === 201) {
        alert("The new email address is already verified! Your booking has been automatically activated.");
        navigate('/');
        return;
      }

      if (response.status !== 200) {
        alert(
          "An error has occurred while changing your email. Please try again later. If the issue persists, please contact us directly to book.",
        );
        return
      }
      
      setEmail(new_email);
      alert("A verification email has been sent to your new email address. Please check your inbox to verify.");
    } catch (error) {
      alert(
        "An error has occurred while changing your email. Please try again later. If the issue persists, please contact us directly to book.",
      );
    } finally {
      setResending(false);
      setActive(false);
    }
  };
  
  return (
    <div className='modal-cont' style={{ display: active ? 'flex' : 'none' }}>
      <form className='modal' onSubmit={change_email}>
        <h1 className='modal-title'>Change Email</h1>
        
        <input 
          name='email'
          className='modal-input' 
          type='email'
          placeholder='Enter new email address'
          required
        />
        
        <div className='modal-btns'>
          <button className='modal-btn' type='button' disabled={resending} onClick={() => setActive(false)}>Cancel</button>
          <button className='modal-btn' type='submit' disabled={resending}>Confirm</button>
        </div>
      </form>
    </div>
  );
}

export default Modal;